import useAuthorization from '@/hooks/useAuthorization';
import UserForm from '@/pages/UserForm';
import Users from '@/pages/Users';
import OrgUsers from '@/pages/OrgUsers';
import { Route } from 'react-router-dom';
import * as urls from '../routePaths';

const UsersRoutes: any = () => {
  const { hasRole } = useAuthorization();

  const routes = [];

  // Super admin routes (legacy user management)
  if (hasRole('super_admin')) {
    routes.push(
      <Route path={urls.USERS_URL} element={<Users />} key="users" />,
      <Route path={urls.CREATE_USER_URL} element={<UserForm />} key="create-user" />,
      <Route path={urls.UPDATE_USER_URL} element={<UserForm />} key="update-user" />,
    );
  }

  // Admin routes (organization user management)
  if (hasRole(['admin', 'super_admin'])) {
    routes.push(<Route path={urls.ORG_USERS_URL} element={<OrgUsers />} key="org-users" />);
  }

  return routes;
};

export default UsersRoutes;
